import { render, staticRenderFns } from "./modal-profile-picture.vue?vue&type=template&id=72657db3&scoped=true&"
import script from "./modal-profile-picture.vue?vue&type=script&lang=js&"
export * from "./modal-profile-picture.vue?vue&type=script&lang=js&"
import style0 from "./modal-profile-picture.vue?vue&type=style&index=0&id=72657db3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72657db3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72657db3')) {
      api.createRecord('72657db3', component.options)
    } else {
      api.reload('72657db3', component.options)
    }
    module.hot.accept("./modal-profile-picture.vue?vue&type=template&id=72657db3&scoped=true&", function () {
      api.rerender('72657db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-profile-picture/modal-profile-picture.vue"
export default component.exports